export const statusMapping = {
	1: 'Quote',
	2: 'Order set',
	3: 'Permits',
	4: 'Invoice sent',
	5: 'Installation',
	7: 'Review',
	10: 'Done',
	6: 'Repair',
};
